import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  updateDoc,
  doc,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase";

export default function CreateStaff() {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [staffs, setStaffs] = useState([]);

  const generatePassword = () => {
    return Math.random().toString(36).slice(-6).toUpperCase();
  };

  /* ================= LOAD STAFF ================= */
  const loadStaffs = async () => {
    const snap = await getDocs(collection(db, "staffs"));
    setStaffs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    loadStaffs();
  }, []);

  /* ================= CREATE ================= */
  const createStaff = async () => {
    if (!name || !mobile) {
      alert("Name & Mobile required");
      return;
    }

    const password = generatePassword();

    await addDoc(collection(db, "staffs"), {
      name,
      mobile,
      password,
      role: "STAFF",
      active: true,
      createdAt: Timestamp.now(),
    });

    alert(`Staff Created
Mobile: ${mobile}
Password: ${password}`);

    setName("");
    setMobile("");
    loadStaffs();
  };

  /* ================= DELETE ================= */
  const deleteStaff = async (id) => {
    if (!window.confirm("Delete this staff?")) return;
    await deleteDoc(doc(db, "staffs", id));
    loadStaffs();
  };

  /* ================= ACTIVE / DEACTIVE ================= */
  const toggleStatus = async (id, currentStatus) => {
    await updateDoc(doc(db, "staffs", id), {
      active: !currentStatus,
    });
    loadStaffs();
  };

  return (
    <div className="container-fluid">
      <h4>Create Staff</h4>

      {/* CREATE FORM */}
      <div className="row mb-3">
        <div className="col-md-3">
          <input
            className="form-control"
            placeholder="Staff Name"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <input
            className="form-control"
            placeholder="Mobile Number"
            value={mobile}
            onChange={e => setMobile(e.target.value)}
          />
        </div>

        <div className="col-md-2">
          <button className="btn btn-primary w-100" onClick={createStaff}>
            Create
          </button>
        </div>
      </div>

      {/* STAFF LIST */}
      <table className="table table-bordered table-sm">
        <thead className="table-dark text-center">
          <tr>
            <th>Sr</th>
            <th>Name</th>
            <th>Mobile</th>
            <th>Password</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {staffs.map((s, i) => (
            <tr key={s.id} className="text-center">
              <td>{i + 1}</td>
              <td>{s.name}</td>
              <td>{s.mobile}</td>
              <td>{s.password}</td>

              {/* STATUS */}
              <td>
                <button
                  className={`btn btn-sm ${
                    s.active ? "btn-success" : "btn-secondary"
                  }`}
                  onClick={() => toggleStatus(s.id, s.active)}
                >
                  {s.active ? "ACTIVE" : "INACTIVE"}
                </button>
              </td>

              {/* DELETE */}
              <td>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteStaff(s.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}